import { render } from "./almacen-shipvia-selector.vue?vue&type=template&id=e632c084"
import script from "./almacen-shipvia-selector.vue?vue&type=script&lang=js"
export * from "./almacen-shipvia-selector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__